import React from 'react';
import type {TaskDefinitionSimpleResponse} from 'src/api/ProactApiClient';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
  TaskDefinitionStateEnum,
  TaskTypeEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {TaskDefinitionTable} from 'src/app/tasks/TaskDefinitionTable/TaskDefinitionTable';
import {useHasModulePermission} from 'src/shared/auth/useHasModulePermission';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export const ListActionDefinitions: React.FC = () => {
  const navigate = useAppNavigate();

  const {hasPermission: hasCreatePermission} = useHasModulePermission({
    module: ModuleEnum.Actions,
    operation: PermissionOperationEnum.Create,
  });

  const handleAddNew = () => navigate(PathUtility.ActionCreate());

  const handleViewClick = (row: TaskDefinitionSimpleResponse) =>
    navigate(PathUtility.ActionView(row.id, 'content'));

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Actions}>
      <TaskDefinitionTable
        identifier="actions-definition-table"
        taskType={TaskTypeEnum.Actions}
        defaultSorting={[{id: 'dueAt', desc: false}]}
        defaultColumnFilters={[
          {
            id: 'state',
            value: [
              TaskDefinitionStateEnum.Draft.toString(),
              TaskDefinitionStateEnum.Published.toString(),
            ],
          },
        ]}
        onCreate={hasCreatePermission ? handleAddNew : undefined}
        onViewRowClick={handleViewClick}
      />
    </ContentWrapper>
  );
};
